import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/app/[locale]/HydrationCheck.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/app/[locale]/NextIntlProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/app/[locale]/RootStoreInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppVersionManager"] */ "/app/apps/data-dashboard/components/AppVersionManager/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/components/Toaster/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.24_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@types+node@20.12.5_react-dom@19.1.3_react@19.1.3__react@19.1.3/node_modules/next/dist/client/script.js");
